import { useLocation } from "react-router";
import React, { useEffect, useState } from "react";

import { inject, observer } from "mobx-react";
import ConversationList from "./ConversationList";
import ConversationContentDetailComponent from "./ConversationContentDetailComponent";
import BottomNavigation from "@/views/CommonComponent/BottomNavigation";
import { Root } from "@/common/Styled/CommonStyled";
import { isConversation } from "@/nativebridge/JsToNative";
import { NativeToJsBridge, NativeToJsEventName } from "@/nativebridge/NativeToJs";
import {useToast} from "@/components/useToast";
import {injectIntl} from "react-intl";

function Conversation(props) {
  const [tabValue, setTabValue] = useState("conversation");
  const { intl, authStore, userStore, conversationStore } = props;
  const { location } = useLocation();
  const { showDeleteToast } = useToast();

  useEffect(() => {
    isConversation(true);
    return () => {
      isConversation(false);
    };
  }, []);
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  useEffect(() => {
    NativeToJsBridge.instance.addEventListener(
        NativeToJsEventName.onSetPushAgree,
        async (event) => {
          const isAgree = event.isAgree;
          console.log("========NativeToJs=========== isAgree=" + isAgree);
            userStore.updateUserPushAgreement(authStore.loginUser.id, isAgree, () => {
                if (!isAgree) {
                    const now = new Date();
                    const formattedDate = `${now.getFullYear()}. ${String(now.getMonth() + 1).padStart(2, '0')}. ${String(now.getDate()).padStart(2, '0')}`;
                    showDeleteToast(
                        <span style={{ whiteSpace: "pre-line" }}>
                            {intl.formatMessage({ id: "Toast_marketing_notification_off" })} {/* 푸시 알림을 거부했습니다. */}
                            &nbsp;{formattedDate}
                        </span>
                    );
                }
            });
        }
    );

    return () => {
      NativeToJsBridge.instance.removeEventListener(
          NativeToJsEventName.onSetPushAgree
      );
    };
  }, []);

  return (
    <Root>
      {tabValue === "conversation" && (
        <>
          <React.Fragment>
            {conversationStore.type === "list" ? (
              <ConversationList />
            ) : (
              <ConversationContentDetailComponent />
            )}
          </React.Fragment>
        </>
      )}
      <BottomNavigation
        value={tabValue}
        handleChangeTab={(event, newValue) => setTabValue(newValue)}
      />
    </Root>
  );
}

export default injectIntl(inject("authStore", "userStore", "conversationStore")(observer(Conversation)));
